import { useEffect, useState } from "react";
import axios from "axios";
import { Star, BadgeCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Testimonials = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    axios.get(`${API}/store/reviews/featured`).then(({ data }) => setReviews(data.reviews || [])).catch(() => {});
  }, []);

  if (reviews.length === 0) {
    return (
      <p className="mt-8 text-sm text-gray-400 italic">
        Join our growing community of herbal wellness seekers across the UK.
      </p>
    );
  }

  return (
    <>
      <p className="mt-10 text-sm text-gray-500">Real reviews from verified Herb Store buyers:</p>
      <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 text-left" data-testid="testimonials-grid">
      {reviews.map((r, i) => (
        <div key={`${r.reviewer_name}-${r.herb_name}-${i}`} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 flex flex-col" data-testid={`testimonial-${i}`}>
          <div className="flex items-center gap-0.5 mb-3">
            {[1, 2, 3, 4, 5].map((s) => (
              <Star key={s} className={`w-4 h-4 ${s <= r.rating ? "text-amber-400 fill-amber-400" : "text-gray-200"}`} />
            ))}
          </div>
          <p className="text-gray-700 text-sm leading-relaxed flex-1">"{r.comment}"</p>
          <div className="mt-4 pt-3 border-t border-gray-50 flex items-center justify-between">
            <span className="text-sm font-semibold text-gray-900 flex items-center gap-1.5">
              {r.reviewer_name}
              {r.verified && <BadgeCheck className="w-4 h-4 text-emerald-500" title="Verified buyer" />}
            </span>
            {r.herb_name && <span className="text-xs text-gray-400">on {r.herb_name}</span>}
          </div>
        </div>
      ))}
      </div>
    </>
  );
};
